import Phaser from "phaser";
export default class HomeScreen extends Phaser.Scene {
    constructor() {
        super ('home-screen-scene')
    }
    init() {
        this.start = undefined
        this.tutorial = undefined
        this.music = undefined
    }
    preload() {
        this.load.image('Background', 'images/Home-Screen.jpg')
        this.load.image('Icon', 'images/Icon.png')
        this.load.spritesheet('Start-btn', 'images/home-button.png', {
            frameWidth: 100, frameHeight: 75
        })
        this.load.audio('Sound', 'music/backsound.mp3')
    }
    create() {
        const gameWidth = this.scale.width*0.5
        const gameHeight = this.scale.height*0.5
        this.add.image(gameWidth, gameHeight, 'Background')
        this.add.image(gameWidth, gameHeight-300, 'Icon')
        this.music = this.sound.add('Sound')
        var soundConfig = {
            loop : true
        }
        this.music.play(soundConfig)
        this.start = this.add.image (gameWidth-200, gameHeight, 'Start-btn')
        .setFrame(0)
        .setScale(3)
        .setInteractive()
        this.start.once('pointerup', () => {
            this.scene.start('character-scene')
            this.music.stop()
        })
        this.tutorial = this.add.image (gameWidth+200, gameHeight, 'Start-btn')
        .setFrame(1)
        .setScale(3)
        .setInteractive()
        this.tutorial.once('pointerup', () => {
            this.scene.start('tutorial-scene')
            this.music.stop()
        })
        this.add.text(30, 910,
        'Note: Made for homework, not business purpose and so on. Do not mean to plagiarize.',
        {fontSize: '30px', fontStyle: 'bold', wordWrap: { width : 900, useAdvancedWrap: true}, color: 'black'})
    }
}